"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _auth = _interopRequireDefault(require("../../services/auth"));
var _Button = _interopRequireDefault(require("../Button"));
var _EmailInput = _interopRequireDefault(require("../EmailInput"));
var _PasswordInput = _interopRequireDefault(require("../PasswordInput"));
var _validators = require("../../util/validators");
var _loginCustomer = _interopRequireDefault(require("../../api/Auth/loginCustomer"));
var _LoginStyled = require("./LoginStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class LoginForm extends _react.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    (0, _defineProperty2.default)(this, "validateEmail", () => {
      const {
        email,
        errors
      } = this.state;
      const {
        t
      } = this.props;
      const message = (0, _validators.validateEmailField)(email);
      this.setState(() => ({
        errors: {
          ...errors,
          email: t(message)
        }
      }));
    });
    (0, _defineProperty2.default)(this, "validatePassword", () => {
      const {
        password,
        errors
      } = this.state;
      const {
        t
      } = this.props;
      const message = (0, _validators.validatePasswordField)(password);
      this.setState(() => ({
        errors: {
          ...errors,
          password: t(message)
        }
      }));
    });
    (0, _defineProperty2.default)(this, "validateFields", () => {
      const {
        email,
        password
      } = this.state;
      const {
        t
      } = this.props;
      const errorFields = {
        email: t((0, _validators.validateEmailField)(email)),
        password: t((0, _validators.validatePasswordField)(password))
      };
      this.setState({
        errors: errorFields,
        generalError: ''
      });
      return !Object.keys(errorFields).find(key => errorFields[key] !== '');
    });
    (0, _defineProperty2.default)(this, "handleSubmit", event => {
      event.preventDefault();
      if (this.validateFields()) {
        this.login();
      }
    });
    (0, _defineProperty2.default)(this, "login", async () => {
      const {
        offerId,
        isMyAccount,
        publisherId,
        onSuccess
      } = this.props;
      const {
        email,
        password
      } = this.state;
      this.setState({
        processing: true,
        hideSuccessMessage: true
      });
      const response = await (0, _loginCustomer.default)(email, password, publisherId ? {
        publisherId
      } : {
        offerId
      });
      if (response.status === 200) {
        _auth.default.login(!!isMyAccount, false, email, response.responseData.jwt, response.responseData.refreshToken, null, null, onSuccess);
      } else if (response.status === 401 || response.status === 422) {
        this.renderError('Wrong email or password');
      } else if (response.status === 429) {
        this.setState({
          overloaded: true
        });
        this.renderError('Server overloaded. Please try again later.', true);
        setTimeout(() => {
          this.setState({
            overloaded: false,
            generalError: ''
          });
        }, 10 * 1000);
      } else {
        this.renderError();
      }
      return true;
    });
    (0, _defineProperty2.default)(this, "renderError", function () {
      let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'An error occurred.';
      const {
        t
      } = _this.props;
      _this.setState({
        processing: false,
        generalError: t(message)
      });
    });
    this.emailInput = /*#__PURE__*/_react.default.createRef();
    this.state = {
      email: '',
      password: '',
      errors: {
        email: '',
        password: ''
      },
      generalError: '',
      processing: false,
      overloaded: false,
      hideSuccessMessage: false
    };
  }
  componentDidMount() {
    if (this.emailInput && this.emailInput.current) this.emailInput.current.focus();
  }
  render() {
    const {
      email,
      password,
      errors,
      generalError,
      processing,
      overloaded,
      hideSuccessMessage
    } = this.state;
    const {
      emailChanged,
      t
    } = this.props;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LoginStyled.FromStyled, {
      onSubmit: this.handleSubmit,
      noValidate: true,
      children: [emailChanged && !generalError && !hideSuccessMessage ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginStyled.FormSuccessStyled, {
        children: t('Your email has been changed succesfully')
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginStyled.FormErrorStyled, {
        children: generalError
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmailInput.default, {
        reference: this.emailInput,
        label: t('Email'),
        floatingLabels: false,
        value: email,
        onChange: e => this.setState({
          email: e
        }),
        onBlur: this.validateEmail,
        error: errors.email
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordInput.default, {
        label: t('Password'),
        floatingLabels: false,
        value: password,
        onChange: e => this.setState({
          password: e
        }),
        onBlur: this.validatePassword,
        error: errors.password
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        type: "submit",
        size: "big",
        theme: "confirm",
        margin: "10px 0",
        disabled: processing || overloaded,
        children: processing ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
          buttonLoader: true,
          color: "#ffffff"
        }) : t('Sign in')
      })]
    });
  }
}
LoginForm.propTypes = {
  offerId: _propTypes.default.string,
  publisherId: _propTypes.default.string,
  isMyAccount: _propTypes.default.bool,
  emailChanged: _propTypes.default.bool,
  onSuccess: _propTypes.default.func,
  t: _propTypes.default.func
};
LoginForm.defaultProps = {
  offerId: '',
  publisherId: '',
  isMyAccount: false,
  emailChanged: false,
  onSuccess: () => {},
  t: k => k
};
var _default = exports.default = LoginForm;